<div
    class="tw:flex tw:h-[min(90vh,40rem)] tw:w-screen tw:flex-col tw:overflow-hidden tw:rounded-lg tw:bg-white tw:shadow-lg tw:md:w-md"
>
    @if (loading()) {
        <div class="tw:flex tw:min-h-0 tw:flex-1 tw:items-center tw:justify-center tw:p-8">
            <app-loader />
        </div>
    } @else if (form) {
        <form class="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col" [formGroup]="form" (ngSubmit)="submit()">
            @if (phase() === 'waiting') {
                <div class="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:overflow-y-auto tw:p-8">
                    <div class="tw:p-4">
                        <app-loader />
                    </div>
                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.waitingPayment' | translate }}
                        </div>
                        <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">{{ form.value.amount | merchantCurrency }}</div>
                    </div>
                </div>
                <div class="tw:flex tw:shrink-0 tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:bg-white tw:p-4">
                    <app-button type="secondary" size="sm" [disabled]="cancellingTeyaPayment()" (clickEvent)="cancelWaitingPayment()">
                        {{ 'GENERAL.cancel' | translate }}
                    </app-button>
                </div>
            } @else if (phase() === 'success') {
                <div class="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:overflow-y-auto tw:px-8 tw:py-16">
                    <app-icon icon="check" [inCircle]="true" extraClass="tw:mb-2 tw:!text-success-500 tw:!bg-success-100 tw:!text-2xl" />
                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.paymentReceived' | translate }}
                        </div>
                        <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">{{ form.value.amount | merchantCurrency }}</div>
                    </div>
                </div>
                <div class="tw:flex tw:shrink-0 tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:bg-white tw:p-4">
                    <app-button type="primary" size="sm" (clickEvent)="close('success')">
                        {{ 'GENERAL.close' | translate }}
                    </app-button>
                </div>
            } @else if (phase() === 'link-sent') {
                <div class="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:overflow-y-auto tw:px-8 tw:py-16">
                    <app-icon
                        icon="send"
                        [inCircle]="true"
                        extraClass="tw:mb-2 tw:!text-primary-500 tw:!bg-primary-50 tw:!text-2xl"
                    />
                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.linkSent' | translate }}
                        </div>
                        <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">
                            {{ form.value.amount | merchantCurrency }} · {{ sentContact() }}
                        </div>
                    </div>
                </div>
                <div class="tw:flex tw:shrink-0 tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:bg-white tw:p-4">
                    <app-button type="primary" size="sm" (clickEvent)="close('success')">
                        {{ 'GENERAL.close' | translate }}
                    </app-button>
                </div>
            } @else if (phase() === 'mbway-sent') {
                <div class="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:overflow-y-auto tw:px-8 tw:py-16">
                    <span
                        class="tw:mb-2 tw:flex tw:h-12 tw:w-12 tw:items-center tw:justify-center tw:overflow-hidden tw:!rounded-full tw:bg-primary-50"
                    >
                        <img src="assets/mbway-mark.png" alt="MB Way" class="tw:h-8 tw:w-8 tw:object-contain" />
                    </span>
                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.mbwaySent' | translate }}
                        </div>
                        <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">
                            {{ form.value.amount | merchantCurrency }} · {{ sentContact() }}
                        </div>
                        <div class="tw:mt-2 tw:text-xs tw:text-neutral-400">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.waitingMbWayApproval' | translate }}
                        </div>
                    </div>
                    <div class="tw:mt-4">
                        <app-loader></app-loader>
                    </div>
                </div>
                <div class="tw:flex tw:shrink-0 tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:bg-white tw:p-4">
                    <app-button type="secondary" size="sm" (clickEvent)="cancelMbWayWaiting()">
                        {{ 'GENERAL.cancel' | translate }}
                    </app-button>
                </div>
            } @else if (phase() === 'failed') {
                <div class="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:overflow-y-auto tw:px-8 tw:py-16">
                    <app-icon icon="close" [inCircle]="true" extraClass="tw:mb-2 tw:!text-error-500 tw:!bg-error-100 tw:!text-2xl" />
                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.paymentFailed' | translate }}
                        </div>
                        <div class="tw:mt-2 tw:text-sm tw:text-neutral-500">
                            {{ errorMessage() || ('SHARED.SIMPLE_PAYMENT_MODAL.paymentFailedDescription' | translate) }}
                        </div>
                        <div class="tw:mt-2 tw:text-sm tw:font-semibold tw:text-neutral-500">
                            {{ form.value.amount | merchantCurrency }}
                        </div>
                    </div>
                </div>
                <div class="tw:flex tw:shrink-0 tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:bg-white tw:p-4">
                    <app-button type="secondary" size="sm" (clickEvent)="cancelFailure()">
                        {{ 'GENERAL.cancel' | translate }}
                    </app-button>
                    <app-button type="primary" size="sm" (clickEvent)="retry()">
                        {{ 'GENERAL.retry' | translate }}
                    </app-button>
                </div>
            } @else {
                <div class="tw:min-h-0 tw:flex-1 tw:overflow-y-auto tw:p-8">
                    <div>
                        <h6 class="tw:h6">{{ 'GENERAL.pay' | translate }}</h6>
                        @if (data.clientName) {
                            <p class="tw:mt-0.5 tw:mb-0 tw:text-sm tw:text-neutral-500">
                                {{ data.clientName }}
                                @if (!showAmountInput() && form.value.amount != null) {
                                    · {{ form.value.amount | merchantCurrency }}
                                }
                            </p>
                        }
                    </div>

                    @if (showAmountInput()) {
                        <div>
                            <app-text-input
                                [submitAttempted]="submitAttempted()"
                                inputType="number"
                                formControlName="amount"
                                label="{{ 'SHARED.SIMPLE_PAYMENT_MODAL.amountLabel' | translate }}"
                                placeholder="{{ 'SHARED.SIMPLE_PAYMENT_MODAL.amountPlaceholder' | translate }}"
                            ></app-text-input>
                            @if (data.amount && form.get('amount')?.value * 100 !== data.amount) {
                                <p class="tw:text-xs tw:text-neutral-400">
                                    {{ 'SHARED.SIMPLE_PAYMENT_MODAL.bookingAmount' | translate }}:
                                    {{ data.amount / 100 | merchantCurrency }}
                                </p>
                            }
                        </div>
                    }

                    <div>
                        <label>{{ 'SHARED.SIMPLE_PAYMENT_MODAL.method' | translate }}</label>
                        <div class="tw:flex tw:flex-col tw:gap-2">
                            @for (option of visibleMethods(); track option.id) {
                                <button
                                    type="button"
                                    (click)="selectPaymentMethod(option.id)"
                                    class="tw:flex tw:w-full tw:items-center tw:gap-3 tw:!rounded-xl tw:border tw:px-4 tw:py-3 tw:text-left tw:text-sm tw:font-medium tw:transition-colors"
                                    [ngClass]="
                                        paymentMethod() === option.id
                                            ? 'tw:border-primary-500 tw:bg-primary-500 tw:text-white'
                                            : 'tw:border-neutral-200 tw:bg-neutral-50 tw:text-neutral-700'
                                    "
                                >
                                    @if (option.logoSrc) {
                                        <span
                                            class="tw:flex tw:h-10 tw:w-10 tw:shrink-0 tw:items-center tw:justify-center tw:overflow-hidden tw:!rounded-full tw:bg-white"
                                        >
                                            <img [src]="option.logoSrc" alt="" class="tw:h-7 tw:w-7 tw:object-contain" />
                                        </span>
                                    } @else {
                                        <app-icon
                                            [icon]="option.icon"
                                            [inCircle]="true"
                                            extraClass="tw:!bg-white"
                                        />
                                    }
                                    <span class="tw:min-w-0 tw:flex-1">
                                        <span class="tw:block">{{ option.labelKey | translate }}</span>
                                        <span
                                            class="tw:block tw:text-xs tw:font-normal"
                                            [ngClass]="paymentMethod() === option.id ? 'tw:text-white/70' : 'tw:text-neutral-400'"
                                            >{{ option.hintKey | translate }}</span
                                        >
                                    </span>
                                    @if (paymentMethod() === option.id) {
                                        <app-icon icon="check" />
                                    }
                                </button>
                            }
                        </div>

                        @if (paymentMethod() === 'bukpay' && isMethodActive('bukpay')) {
                            <div class="tw:mt-2 tw:space-y-3 tw:!rounded-xl tw:border tw:border-neutral-200 tw:bg-neutral-50 tw:p-4">
                                <div>
                                    <label class="tw:mb-1.5 tw:block tw:text-sm tw:font-medium tw:text-neutral-700">{{
                                        'SHARED.SIMPLE_PAYMENT_MODAL.emailLabel' | translate
                                    }}</label>
                                    <app-text-input
                                        [submitAttempted]="submitAttempted()"
                                        [hasMarginB]="false"
                                        inputType="email"
                                        formControlName="email"
                                        placeholder="{{ 'SHARED.SIMPLE_PAYMENT_MODAL.emailPlaceholder' | translate }}"
                                        invalidMsg="{{ 'GENERAL.invalidEmail' | translate }}"
                                    ></app-text-input>
                                </div>
                                <p class="tw:mb-0 tw:text-xs tw:text-neutral-400">
                                    {{ 'SHARED.SIMPLE_PAYMENT_MODAL.emailHelper' | translate }}
                                </p>
                            </div>
                        }

                        @if (paymentMethod() === 'mbway_request' && isMethodActive('mbway_request')) {
                            <div class="tw:mt-2 tw:space-y-3 tw:!rounded-xl tw:border tw:border-neutral-200 tw:bg-neutral-50 tw:p-4">
                                <div>
                                    <label class="tw:mb-1.5 tw:block tw:text-sm tw:font-medium tw:text-neutral-700">{{
                                        'SHARED.SIMPLE_PAYMENT_MODAL.phoneLabel' | translate
                                    }}</label>
                                    <app-phone-input
                                        [form]="form"
                                        controlName="phoneNumber"
                                        [submitAttempted]="submitAttempted()"
                                    ></app-phone-input>
                                </div>
                                <p class="tw:mb-0 tw:text-xs tw:text-neutral-400">
                                    {{ 'SHARED.SIMPLE_PAYMENT_MODAL.phoneHelper' | translate }}
                                </p>
                            </div>
                        }
                    </div>

                    @if (needsActivation()) {
                        <div class="tw:mt-4 tw:!rounded-xl tw:border tw:border-warning-200 tw:bg-warning-50 tw:px-4 tw:py-3">
                            <div class="tw:flex tw:items-start tw:gap-2">
                                <app-icon icon="warning" extraClass="tw:!text-warning-500" />
                                <div>
                                    <div class="tw:text-sm tw:font-medium tw:text-neutral-800">
                                        {{ 'SHARED.SIMPLE_PAYMENT_MODAL.methodNotActive' | translate }}
                                    </div>
                                    <p class="tw:mb-0 tw:mt-1 tw:text-xs tw:text-neutral-500">
                                        {{ selectedMethodOption()?.activateHintKey | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }

                    @if (showModuleUpsells()) {
                        <div class="tw:mt-4 tw:flex tw:flex-col tw:gap-2">
                            <p class="tw:mb-0 tw:text-xs tw:font-medium tw:uppercase tw:tracking-wide tw:text-neutral-400">
                                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.notUsingYet' | translate }}
                            </p>
                            @if (!isSalesModuleActive()) {
                                <a
                                    class="tw:flex tw:items-start tw:gap-3 tw:!rounded-xl tw:border tw:border-neutral-200 tw:px-4 tw:py-3 tw:no-underline tw:transition-colors hover:tw:bg-neutral-50"
                                    [routerLink]="['/', currentStore()?.slug, 'dashboard', 'extensions', 'sales']"
                                    (click)="close()"
                                >
                                    <app-icon icon="shopping_bag" [inCircle]="true" />
                                    <span class="tw:min-w-0 tw:flex-1">
                                        <span class="tw:block tw:text-sm tw:font-medium tw:text-neutral-900">{{
                                            'SHARED.SIMPLE_PAYMENT_MODAL.salesModuleTitle' | translate
                                        }}</span>
                                        <span class="tw:mt-0.5 tw:block tw:text-xs tw:text-neutral-400">{{
                                            'SHARED.SIMPLE_PAYMENT_MODAL.salesModuleDescription' | translate
                                        }}</span>
                                    </span>
                                    <span class="tw:shrink-0 tw:self-center tw:text-sm tw:font-medium tw:text-primary-600">{{
                                        'SHARED.SIMPLE_PAYMENT_MODAL.learnMore' | translate
                                    }}</span>
                                </a>
                            }
                            @if (!isInvoicingActive()) {
                                <a
                                    class="tw:flex tw:items-start tw:gap-3 tw:!rounded-xl tw:border tw:border-neutral-200 tw:px-4 tw:py-3 tw:no-underline tw:transition-colors hover:tw:bg-neutral-50"
                                    [routerLink]="['/', currentStore()?.slug, 'dashboard', 'extensions', 'invoicing']"
                                    (click)="close()"
                                >
                                    <app-icon icon="receipt" [inCircle]="true" />
                                    <span class="tw:min-w-0 tw:flex-1">
                                        <span class="tw:block tw:text-sm tw:font-medium tw:text-neutral-900">{{
                                            'SHARED.SIMPLE_PAYMENT_MODAL.invoicingModuleTitle' | translate
                                        }}</span>
                                        <span class="tw:mt-0.5 tw:block tw:text-xs tw:text-neutral-400">{{
                                            'SHARED.SIMPLE_PAYMENT_MODAL.invoicingModuleDescription' | translate
                                        }}</span>
                                    </span>
                                    <span class="tw:shrink-0 tw:self-center tw:text-sm tw:font-medium tw:text-primary-600">{{
                                        'SHARED.SIMPLE_PAYMENT_MODAL.learnMore' | translate
                                    }}</span>
                                </a>
                            }
                        </div>
                    }

                    @if (isMethodActive('terminal') && paymentMethod() === 'terminal' && !isInvoicingActive()) {
                        <div class="tw:border-neutral-200 tw:!rounded-xl tw:border tw:px-4 tw:py-3 tw:mt-4">
                            <div class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:text-sm tw:font-medium tw:text-neutral-400">
                                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.invoiceTitle' | translate }}
                            </div>
                            <div class="tw:mt-1.5 tw:text-xs tw:text-neutral-400">
                                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.invoiceDescription' | translate }}
                                <a
                                    class="tw:text-primary-600 tw:hover:text-primary-700 tw:font-medium"
                                    (click)="close()"
                                    [routerLink]="['/', currentStore()?.slug, 'dashboard', 'extensions', 'invoicing']"
                                    >{{ 'SHARED.SIMPLE_PAYMENT_MODAL.learnMore' | translate }}</a
                                >
                            </div>
                        </div>
                    }
                </div>

                <div class="tw:flex tw:shrink-0 tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:bg-white tw:p-4">
                    <app-button [disabled]="saving()" type="secondary" size="sm" (clickEvent)="close()">
                        {{ 'GENERAL.cancel' | translate }}
                    </app-button>
                    @if (needsActivation()) {
                        <app-button [disabled]="saving()" type="primary" size="sm" (clickEvent)="goActivate()">
                            {{ selectedMethodOption()?.activateLabelKey | translate }}
                        </app-button>
                    } @else {
                        <app-button [disabled]="saving()" [loading]="saving()" buttonType="submit" size="sm">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.send' | translate }}
                        </app-button>
                    }
                </div>
            }
        </form>
    }
</div>
